import {
  AppBar,
  Box,
  Button,
  Grid,
  makeStyles,
  Toolbar,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { RiFilterLine } from 'react-icons/ri';
import {
  getExamModuleListData,
  getGradingCourseDetails,
} from '../../../../Utils/apiServices';
import ModerationList from './ModerationList';

import KenDialogBox from '../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../global_components/KenSelect';
import KenDateTimePicker from '../../../../global_components/KenDateTimePicker';

const useStyles = makeStyles((theme) => ({
  main: {
    padding: '32px 0px',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: ' ',
  },
}));

const selectOptionsBatch = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'February',
    value: 'February',
  },
  {
    label: 'April',
    value: 'April',
  },
  {
    label: 'October',
    value: 'October',
  },
  {
    label: 'December',
    value: 'December',
  },
];
const ExamModeration = () => {
  const classes = useStyles();
  const [course, setCourse] = useState([]);
  const [loading, setLoading] = useState(false);

  // For FIlter Status
  const [filterData, setFilterData] = useState();

  const [examMonthData, setExamMonthData] = useState([]);
  const [selectCourseData, setselectCourseData] = useState([]);
  const [selectTermData, setselectTermData] = useState([]);
  const [selectCampusData, setselectCampusData] = useState([]);

  const [selectFacultyData, setselectFacultyData] = useState([]);

  const [filterDialog, setFilterDialog] = useState(false);

  const [examDate, setexamDate] = useState('');

  const manageexamDate = (e, row) => {
    setexamDate(e.target.value);
  };

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }
  const [selectValueCampus, setSelectValueCampus] = useState('');
  const handleSelectChangeCampus = (e) => {
    setSelectValueCampus(e.target.value);
  };
  const [selectValueProgram, setSelectValueProgram] = useState('');
  const handleSelectChangeProgram = (e) => {
    setSelectValueProgram(e.target.value);
  };

  const [selectValueSubject, setSelectValueSubject] = useState('');
  const handleSelectChangeSubject = (e) => {
    setSelectValueSubject(e.target.value);
  };

  const [selectValueTerm, setSelectValueTerm] = useState('');
  const handleSelectChangeTerm = (e) => {
    setSelectValueTerm(e.target.value);
    setSelectValueProgram('')
  };

  const [selectValueBatch, setSelectValueBatch] = useState('');
  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };
  const [selectValueBatch1, setSelectValueBatch1] = useState([]);

  const [selectValueBatch12, setSelectValueBatch12] = useState('');
  const handleSelectChangeBatch12 = (e) => {
    setSelectValueBatch(e.target.value);
  };

  const [selectValueExamCycle1, setSelectValueExamCycle1] = useState([]);

  const [selectValueExamCycle, setSelectValueExamCycle] = useState('');
  const handleSelectChangeExamCycle = (e) => {
    setSelectValueExamCycle(e.target.value);
  };

  // For Filter
  useEffect(() => {
    getExamModuleListData().then((res) => {
      setFilterData(res);
    });
  }, []);

  useEffect(() => {
    let TermListData = filterData?.TermList.map((item) => {
      return {
        label: item.TermName,
        value: item.TermName,
      };
    });
    setselectTermData(TermListData);

    // For Course
    let CourseListData = filterData?.CourseList.filter((item) => {
      return (
        selectValueTerm == item.TermName && item.TermName && item.CourseName
      );
    }).map((item) => {
      return {
        label: item.CourseName,
        value: item.CourseName,
      };
    });

    setselectCourseData(CourseListData);

    // For Faculty
    let FacultyListData = filterData?.courseFacultyList
      .filter((item) => {
        console.log('item---Fac', item);
        return selectValueProgram === item.CourseName;
      })
      .map((itemss) => {
        let Fcaulty = itemss?.FacultyName?.map((item) => {
          return {
            label: item,
            value: item,
          };
        });

        return Fcaulty;
        // setselectFacultyData1(Fcaulty);
      });
    setselectFacultyData(FacultyListData);
    //For Campus
    let CampusListData = filterData?.campus.map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setselectCampusData(CampusListData);
    // let BatchListData = filterData?.batchList
    //   .map((item) => {
    //     return {
    //       label: item,
    //       value: item,
    //     };
    //   })
    //   .filter((data) => {
    //     return data.label != null && data.value != null;
    //   });

    let BatchListData = filterData?.batchList
      .map((item) => {
        return {
          label: item,
          value: item,
        };
      })
      .filter((data) => {
        return data.label != null && data.value != null;
      });

    setSelectValueBatch1(BatchListData);

    let ExamCycleListData = filterData?.ExamMonthList.map((item) => {
      return {
        label: item,
        value: item,
      };
    }).filter((data) => {
      return data.label != null && data.value != null;
    });

    setSelectValueExamCycle1(ExamCycleListData);
  }, [filterData, selectValueTerm, selectValueProgram]);

  //Pagination

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [totalData, setTotalData] = useState(25);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getGradingData = () => {
    setLoading(true);
    let filterData = {
      term: selectValueTerm,
      course: selectValueProgram,
      campus: selectValueCampus,
      subjectFaculty: selectValueSubject,
      status: '',
      examCycle: selectValueExamCycle,
      batch: selectValueBatch,
      pageNo: page,
      count: rowsPerPage,
      // deadline: deadlineDate,
      // dateOfExam: examDate,
      // allocatedTo: selectValueAlloctedFaculty,
      // batch: selectValueBatch,
      // examCycle: selectValueExamCycle,
    };
    getGradingCourseDetails(filterData)
      .then((res) => {
        setLoading(false);
        const ModerationListData =
          res?.evalutionList === null ? [] : res?.evalutionList;
        if (res !== null) {
          setCourse(ModerationListData);
        }
        setTotalData(res.noOfRecords);
      })
      .catch((err) => {
        setLoading(false);
        console.log(' Grading Course Details error', err);
      });
    setFilterDialog(false);
  };
  useEffect(() => {
    getGradingData();
  }, [page, rowsPerPage]);
  return (
    <Box className={classes.main}>
      {' '}
      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Moderation Filter
          </Typography>
        }
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => getGradingData()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Term"
              options={selectTermData}
              value={selectValueTerm}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeTerm}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={selectCourseData}
              value={selectValueProgram}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeProgram}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Campus"
              options={selectCampusData}
              value={selectValueCampus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCampus}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Subject Faculty"
              options={selectFacultyData?.[0]}
              value={selectValueSubject}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeSubject}
              required
            />
          </Grid>

          {/* <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Status"
              options={selectOptionsBatch}
              value={selectValueBatch}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch}
              required
            />
          </Grid> */}

          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label="Date Of Exam"
              inputBaseRootClass={classes.kenDateTimePickerColor}
              placeholder="Date Of Exam"
              value={examDate}
              type="date"
              required={true}
              defaultValue={examDate}
              onChange={manageexamDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectValueBatch1}
              value={selectValueBatch}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch12}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Exam Cycle"
              options={selectValueExamCycle1}
              value={selectValueExamCycle}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeExamCycle}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Exam Moderation
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px', height: '28px', width: '78px' }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button>

            {/* <Button
              variant="contained"
              color="primary"
              className={classes.addButton}
              to={'#'}
            >
              Save
            </Button> */}
          </Grid>
        </Toolbar>
      </AppBar>
      <ModerationList
        course={course}
        setCourse={setCourse}
        setLoading={setLoading}
        loading={loading}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        totalData={totalData}
      />
    </Box>
  );
};

export default ExamModeration;
